import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface UpdateTrialStudentAttendanceParam {
  studentId: string;
  isPresent: boolean;
}

export const updateTrialStudentAttendanceAPI = async ({
  studentId,
  isPresent,
}: UpdateTrialStudentAttendanceParam) => {
  const resp = await baseAPI.patch<unknown>(
    `/trialstudents/${studentId}/attendance`,
    {
      isPresent,
    },
  );
  return resp.data;
};

export const useUpdateTrialStudentAttendanceMutation = () => {
  return useMutation({
    mutationFn: async (
      attendanceDetails: UpdateTrialStudentAttendanceParam,
    ) => {
      const response = await updateTrialStudentAttendanceAPI(attendanceDetails);
      return response;
    },
    onSuccess: (_) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRIAL_STUDENTS],
      });
    },
  });
};
